<template>
  <div class="knowDynamic tw-w-full tw-bg-white tw-px-4" style="margin: 40px 0;">
    <div class="tw-flex tw-flex-col tw-items-center">
      <h2 class="main-title" v-html="$t('了解天晟最新动态')"></h2>
      <p class="sub-title">
        {{ $t("获取天晟在产业区块链与Web3领域的前沿洞察、实战案例与深度观点") }}
      </p>
      <div class="dynamic-main">
        <div class="card-grid">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            class="card-item"
            @click="handleClickRoute(item)"
          >
            <img
              :src="item?.coverImage || defaultImage"
              alt=""
              class="card-image"
            />
            <div class="card-content">
              <p class="card-title">{{ item.title }}</p>
            </div>
          </div>
        </div>
        <div class="more-btn" @click="handleClickRoute()">
          <span>{{ $t("更多动态") }}</span>
          <span> ></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { articlesApi } from "@/api/modules/home";
export default {
  name: "knowDynamic",
  props: {},
  components: {},
  data() {
    return {
      isVisible: false,
      observer: null,
      defaultImage: new URL("@/assets/home/01.png", import.meta.url).href,
      dataList: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getList();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1, // 当组件10%可见时触发
        }
      );

      this.observer.observe(this.$el);
    },

    async getList() {
      const { code, data } = await articlesApi({
        pageSize: 4,
        pageIndex: 1,
      });
      if (code === 0) {
        this.dataList = data.list;
      }
    },
    handleClickRoute(item) {
      if (!item) {
        this.$router.push({
          path: `/dynamics`,
        });
        return;
      }
      localStorage.setItem("detailForm", JSON.stringify(item));
      const routeData = this.$router.resolve({
        path: `/dynamics/` + item.id,
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.knowDynamic {
  width: 100%;
}

.main-title {
  font-weight: 600;
  font-size: 20px;
  color: #111111;
  text-align: center;
  margin-bottom: 12px;
}

.sub-title {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  text-align: center;
  width: 100%;
  padding: 0 16px;
}

.dynamic-main {
  width: 100%;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 20px;
}

.card-item {
  width: 100%;
  aspect-ratio: 162 / 142;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0px 0px 20px 0px rgba(0, 14, 72, 0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
}

.card-item:hover {
  box-shadow: 0px 0px 20px 0px rgba(0, 14, 72, 0.1);
}

.card-image {
  width: 100%;
  height: 60%;
  object-fit: cover;
  border-radius: 16px 16px 0 0;
}

.card-content {
  flex: 1;
  padding: 12px;
  background: #FFFFFF;
  border-radius: 0 0 16px 16px;
  display: flex;
  align-items: center;
}

.card-title {
  font-weight: 600;
  font-size: 12px;
  color: #111111;
  line-height: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.more-btn {
  font-weight: 500;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.more-btn:hover {
  color: #4077F8;
}
</style>
